<template>
	<div>
		<div class="shadow-md border-solid border-t-4 border-indigo-600 rounded-t">
			<h2 class="text-xl p-4">Recent Activity</h2>
			<table class="w-full">
				<thead>
					<th class="pl-4">Type</th>
					<th>Revisit</th>
					<th class="text-right">Visited On</th>
				</thead>
				<tbody>
					<tr v-for="(row, rowIndex) in activity" :key="rowIndex">
						<td class="pl-4 text-base">{{ row.type }}</td>
						<td>
							<span class="text-base" v-html="row.link"></span>
						</td>
						<td class="text-right leading-normal">
							<p class="text-base">{{ row.updated_at | date }}</p>
							<p class="text-sm">{{ row.updated_at | time }}</p>
						</td>
					</tr>
				</tbody>
			</table>
			<div v-if="! activity" class="text-xl text-center p-6">No Recent Activity</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			recentActivity: {
				type: Array,
				required: true
			}
		},

		data() {
			return {
				activity: this.recentActivity
			}
		}
	}
</script>